import React, { useState, useEffect } from "react";
import "./landingPage.css";
import { useNavigate, useParams } from 'react-router-dom';
import { decryptObject } from '../../hooks/decrypt'
import { acceptInvitation, rejectInvitation, verifyInvitation, IndentifyUserData } from '../../api/api'
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaAppStoreIos } from "react-icons/fa6";
// import { SiTicktick } from "react-icons/si";

export default function LandingPage() {

    const [user, setUser] = useState({});
    const { encryptString } = useParams();
    const navigate = useNavigate();
    const [validToken, setValidToken] = useState(false);
    const [tokenLoader, setTokenLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {

        verifyInviteToken(encryptString);
        IndentifyUser(encryptString)

    }, []);

    const verifyInviteToken = async (encryptString) => {
        try {
            const { status, message } = await verifyInvitation(encryptString);
            console.log('verifyInviteToken API Response:', status, message);
            if (status) {
                setValidToken(true);
                setTimeout(() => {
                    setTokenLoader(true);
                }, 2000);
            } else {
                setErrorMessage(message || 'Invalid token.');
            }
        } catch (error) {
            console.error('verifyInviteToken Error:', error);
            setErrorMessage(error.message || 'Something went wrong.');
        }
    };

    const IndentifyUser = async (encryptString) => {

        try {
            const { status, message, result } = await IndentifyUserData(encryptString);
            console.log('IndentifyUser API Response:', result);
            if (status) {
                setUser(result)
            } else {
                setErrorMessage(message);
            }
        } catch (error) {
            console.error('IndentifyUser Error:', error);
            setErrorMessage(error.message || 'Something went wrong.');
        }

    };

    const handleAcceptSubmit = async () => {
        try {
            const { status, message } = await acceptInvitation(encryptString)
            console.log('handleAcceptSubmit res', status, message)
            messageShowHandler("Invitation accepted successfully");

        } catch (error) {
            console.log('handleAcceptSubmit', error)
        }
    }

    const handleDeclineSubmit = async () => {
        try {
            const { status, message } = await rejectInvitation(encryptString)
            console.log('handleDeclineSubmit res', status, message)
            messageShowHandler("Invitation Declined successfully!");

        } catch (error) {
            console.log('handleDeclineSubmit', error)
        }
    }

    const messageShowHandler = (msgText) => {
        navigate("/response", { state: msgText });
    }


    return (
        <div className='landingPage'>
            {console.log("UserData", user)}
            {
                !tokenLoader &&
                <div className="loaderContainer">
                    {validToken ? (
                        <h2>Link Verified Successfully</h2>
                    ) : errorMessage ? (
                        <h2 className="error">{errorMessage}</h2>
                    ) : (
                        <span className="loaderAnimation">Loading...</span>
                    )}
                </div>
            }
            {
                user === "KevlarUser" &&
                <div className='landingContentPart'>
                    <h3 className='headingtext'>
                        Keyholder Role Invitation – Awaiting Your Decision.
                    </h3>
                    <h3 className='paraText'>You are invited to take on the Keyholder role. Click 'Accept' to proceed or 'Decline' if you do not wish to accept.</h3>
                    <div className='btnWrapper'>
                        <button className='primaryBtn' onClick={handleAcceptSubmit}>Accept Invitation</button>
                        <button className='cancelBtn' onClick={handleDeclineSubmit}>Decline Invitation</button>
                    </div>
                </div>
            }
            {
                user === "nonkevlarUser" &&
                <div className='landingContentPart'>
                    <h3 className='headingtext'>you are not a Kevlar user. Please register first using the provided Play Store or App Store link to proceed with the Keyholder process.</h3>
                    <p className="commingSoonText">Coming Soon...</p>
                    <div className="linksWrapper">
                        <a href="#"><IoLogoGooglePlaystore /><span>Play Store</span></a>
                        <a href="#"><FaAppStoreIos /><span>App Store</span></a>
                    </div>
                </div>
            }
        </div>
    )
}
